export default "__VITE_ASSET__Cxj0vU0d__"